import { cacheService, productActions, localStore } from '../../services';
import { validateResponse } from '../../util/authenticatonValidation';
import { priceDispatcher, stockDispatcher } from '..';
import { convertToLineItem, convertToStockItem, getAccessories, apiException } from '../../util';
import { uniq, isEmpty } from 'lodash';

export const productsDispatcher = dispatch => ( {
  // getProduct( code ) {
  //   // first reset
  //   dispatch( { type: productActions.GET, code } );
  //   return cacheService( 'products' ).get( this.updatedUrl(code) )
  //     .then( validateResponse( dispatch ) )
  //     .then( data => 
  //       // apiException(data, dispatch);
  //       dispatch( { code, type: productActions.LOAD, product: data.data } ) )
  //     .catch( () => dispatch( { code, type: productActions.LOAD, product: null } ) );
  // },
  getProduct( code ) {
    // first reset
    dispatch( { type: productActions.GET, code } );
    return cacheService( 'products' ).get( this.updatedUrl(code) )
      .then( validateResponse( dispatch ) )
      .then( data => dispatch( { code, type: productActions.LOAD, product: data.data } ) )
      .catch( () => dispatch( { code, type: productActions.LOAD, product: null } ) );
  },
  updatedUrl(code){
  const updatedCode = code;
  if(updatedCode.includes(".")){
    return updatedCode+'/';
  }
  else{
    return code;
  }
  },
  // getProducts( codes, bomItems, user ) {
  //   // first reset
  //   dispatch( { type: productActions.GET, code: codes } );
  //   return cacheService( 'products' ).post( codes ).then( validateResponse( dispatch ) ).then( data => {
  //     // if(bomItems && user){
  //     //   priceDispatcher( dispatch ).getPrices( data.data?.map( product=> convertToLineItem(product, user) ) );
  //     // }
  //     // if(codes && codes.length > 0) {
  //     // apiException(data, dispatch);
  //     // }
  //     dispatch( { code: codes, type: productActions.LOAD, products: data.data } ) });
  // },
  getProducts( codes ) {
    // first reset
    dispatch( { type: productActions.GET, code: codes } );
    return cacheService( 'products' ).post( codes ).then( validateResponse( dispatch ) ).then( data => dispatch( { code: codes, type: productActions.LOAD, products: data.data } ) );
  },
  getProductsInCart( user ) {
    const cartInLocalStore = localStore.get( 'cart' );
    if( !isEmpty( cartInLocalStore ) ){
      let codes = [];
      cartInLocalStore && cartInLocalStore.stack.forEach(stackKey => {
        if( stackKey != 'lastUpdated' && stackKey != 'stack'){
          codes.push(cartInLocalStore[stackKey].product.code);
          if(cartInLocalStore[stackKey].product.configuration){
            const accessoryCodes = getAccessories( cartInLocalStore[stackKey].product );
            codes = codes.concat( accessoryCodes || [])
          }
          let prod = cartInLocalStore[stackKey].product;
          if( prod.additionalProducts && prod.additionalProducts.length > 0){
            codes.push( prod.additionalProducts[0].code );
            if( prod.additionalProducts[0].configuration ){
              const addaccessoryCodes = getAccessories( prod.additionalProducts[0] );
              codes = codes.concat( addaccessoryCodes || [])
            }
          }
        }
      });
      codes = uniq(codes);
      // first reset
      dispatch( { type: productActions.GET, code: codes } );
      return cacheService( 'products' ).post( codes ).then( validateResponse( dispatch ) )
      .then( data => dispatch( { code: codes, type: productActions.LOAD, products: data.data } ) )
      .then( response => {
        priceDispatcher( dispatch ).getPrices( response.products.map( product=> convertToLineItem(product, user) ) );
        stockDispatcher( dispatch ).getStocks( response.products.map( convertToStockItem ) );
        return response;
      } );
    }
  }
} );
